









































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";
import { BaseModule } from "@/store/base.module";
import { ReportsModule } from "@/store/reports.module";

@Component({})
export default class PayInstruction extends Mixins(FormValidator) {
  is_budget: boolean;
  current_year: number = new Date().getFullYear();
  get showConsNotDialog() {
    return AuthModule.ShowConsumptionNotification;
  }
  set showConsNotDialog(val) {
    AuthModule.setShowConsumptionNotification(val);
  }
  get isKz() {
    return this.$i18n.locale === "kk";
  }
  get budget_cons_not_str7() {
    return this.$t("budget_cons_not.str7", {
      current_year: this.current_year,
    });
  }
  get other_cons_not_str5() {
    return this.$t("other_cons_not.str5", {
      current_year: this.current_year,
    });
  }
  async mounted() {
    BaseModule.setLoadingStatus(true);
    const notif = await ReportsModule.getPowerModeNotifData(
      this.$route.params.id,
    );
    if (notif) this.is_budget = notif.is_budget;
    BaseModule.setLoadingStatus(false);
  }
}
